import showSpinner from '@services/addSpinnerOnQueryStarted';
import appendPath from '@services/path';
import { applyUkgTimeZoneTransformationToProps } from '@commonClient/services/ukgDateTime';

const BASE_PATH = 'api/v1/manager/Utilities';
const appendToApiPath = appendPath(BASE_PATH);

export const TEAM_DEFINITIONS_TAG = 'TeamDefinitions';
export const TEAM_DEFINITIONS_TAGS = [TEAM_DEFINITIONS_TAG];

const applyUserTimeZoneConversionMapping = applyUkgTimeZoneTransformationToProps(['startDate', 'endDate']);
/**
 * @param {import('@reduxjs/toolkit/dist/query/endpointDefinitions').EndpointBuilder<any, string, string>} builder
 * @returns {import('@reduxjs/toolkit/dist/query').QueryDefinition<void, any, any, VBD.ITeamDefinition[]>}
 */
const getTeamDefinitions = (builder) =>
    builder.query({
        query: () => ({ url: appendToApiPath('TeamDefinitions'), method: 'GET' }),
        async onQueryStarted(id, api) { await showSpinner(api); },
        transformResponse: (td) => td.map(applyUserTimeZoneConversionMapping),
        providesTags: (result) => (result ? result.map(({ id }) => ({ type: TEAM_DEFINITIONS_TAG, id })) : [TEAM_DEFINITIONS_TAG]),
    });

export const endpointsTeamDefinitions = (builder) => ({
    getTeamDefinitions: getTeamDefinitions(builder),
});
